import { API_ORIGIN } from "services/api";

// The API returns image paths inconsistently: sometimes an absolute URL (S3/CDN),
// sometimes a server-relative path with or without a leading slash. Blindly
// concatenating API_ORIGIN breaks both of those cases, so normalise here.
const resolveAssetUrl = (path) => {
  if (!path || typeof path !== "string") return "";

  const trimmed = path.trim();
  if (!trimmed) return "";
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith("data:")) return trimmed;

  return `${API_ORIGIN}/${trimmed.replace(/^\/+/, "")}`;
};

export default resolveAssetUrl;
